import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import MatchList from "../Match/components/MatchList";

import { getTournamentListApi } from "./TournamentController";
import { getMatchListApi } from "../Match/MatchController";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";

const Tournaments = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.language);

  const [ongoingTournamentList, setOngoingTournamentList] = useState([]);
  const [upcomingTournamentList, setUpcomingTournamentList] = useState([]);
  const [matchList, setMatchList] = useState([]);

  useEffect(() => {
    getTournamentList();
    getMatchList();
  }, []);

  const getTournamentList = () => {
    try {
      dispatch(loaderStateTrue());
      getTournamentListApi()
        .then((response) => {
          let responseData = response.data || [];
          const today = new Date();
          const ongoing = responseData.filter((item) => {
            const start = new Date(item.startDate);
            const end = new Date(item.endDate);
            return today >= start && today <= end;
          });

          const upcoming = responseData.filter((item) => {
            const start = new Date(item.startDate);
            return today < start;
          });

          // Set the states
          setOngoingTournamentList(ongoing);
          setUpcomingTournamentList(upcoming);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };

  const getMatchList = () => {
    try {
      dispatch(loaderStateTrue());
      getMatchListApi()
        .then((response) => {
          let responseData = response?.data?.result || [];
          console.log("responseDataresponseDataresponseData",responseData)
          setMatchList(responseData);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };

  return (
    <main className="main p-4 relative">
      <div className="flex flex-wrap items-start gap-y-6 -mx-2">
        <div className="lg:w-4/6 w-full px-2">
          <div className="space-y-5">
            <div className="flex flex-wrap -mx-2">
              <div className="xs:w-1/2 w-full px-2">
                <div className="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                  <div className="p-5 relative space-y-3">
                    <div className="flex justify-between items-center gap-4 w-full">
                      <h3 className="flex-1 font-secondary text-2xl uppercase bg-gradient-to-r from-primary-950 to-primary-500 bg-clip-text text-transparent font-black">
                        {t("tournamentsOngoing")}
                      </h3>
                      <div className="flex-none w-16 font-secondary font-black lg:text-5xl text-4xl">
                        {ongoingTournamentList?.length}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="xs:w-1/2 w-full px-2">
                <div className="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                  <div className="p-5 relative space-y-3">
                    <div className="flex justify-between items-center gap-4 w-full">
                      <h3 className="flex-1 font-secondary text-2xl uppercase bg-gradient-to-r from-primary-950 to-primary-500 bg-clip-text text-transparent font-black">
                        {t("upcomingTournaments")}
                      </h3>
                      <div className="flex-none w-16 font-secondary font-black lg:text-5xl text-4xl">
                        {upcomingTournamentList?.length}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <h3 className="xl:text-2xl text-xl font-extrabold uppercase">
                {t("recentMatches")}
              </h3>
              <select className="form-select font-bold !max-w-[200px]">
                <option value="">Ligue 1 McDonald's</option>
                <option value="">Ligue 2 McDonald's</option>
              </select>
              <button className="btn btn-primary text-nowrap ml-auto">
                {t("seeAll")}
              </button>
            </div>
            <MatchList matchList={matchList} />
          </div>
        </div>
        <div className="lg:w-2/6 w-full px-2 sticky top-20">
          <div className="space-y-5">
            <div className="relative">
              <div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
                <div className="absolute -skew-x-[20deg] w-[4vw] top-0 -left-12 bottom-0 bg-[#3D54AC]"></div>
                <div className="absolute -skew-x-[20deg] w-[18vw] top-0 -right-12 bottom-0 bg-[#3D54AC] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/10"></div>
              </div>
              <div className="relative bg-cover bg-no-repeat bg-center h-full">
                <div className="flex lg:justify-end justify-end max-sm:flex-wrap gap-y-3 w-full">
                  <div className="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
                    <img
                      src="assets/images/club-players/paris.png"
                      alt=""
                      className="max-w-full lg:max-h-[276px] inline-block"
                    />
                  </div>
                </div>
                <div className="absolute left-0 bottom-0 right-0 p-4 flex justify-between items-end gap-6 bg-gradient-to-t from-[#3D54AC] rounded-b-xl overflow-hidden">
                  <div className="">
                    <div className="space-y-2">
                      <div className="flex items-center gap-x-4">
                        <span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
                          <img
                            src="assets/images/icons/star-fill.svg"
                            alt="Star"
                            width="16"
                            className="icon-white"
                          />{" "}
                          4.5
                        </span>
                      </div>

                      <h4 className="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase text-white">
                        Ousmane Dembélé
                      </h4>
                    </div>
                  </div>
                  <div className="">
                    <button className="btn btn-primary text-nowrap ml-auto">
                      {t("seeAll")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative rounded-xl overflow-hidden">
              <div className="rounded-xl absolute inset-0 bg-[#F5F5F5] overflow-hidden">
                <div className="w-[15vw] h-[15vw] rounded-[50%] bg-[#F022AC] blur-[50px] absolute -top-[8vw] -left-10 opacity-50"></div>
                <div className="w-[20vw] h-[20vw] rounded-[50%] bg-[#FB4A4A] blur-[50px] absolute -top-[5vw] -right-20"></div>
              </div>
              <div className="relative bg-cover bg-no-repeat bg-center h-full">
                <div className="relative">
                  <img
                    src="assets/images/football-stadium.png"
                    alt=""
                    className="max-w-full inline-block"
                  />
                </div>

                <div className="p-4 flex flex-col justify-between gap-6">

                  <div className="space-y-2">
                    <h4 className="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase">
                      Create a new Tournament
                    </h4>
                    <p className="font-secondary font-semibold text-gray-400">
                      Lorem Ipsum is simply dummy text.
                    </p>
                  </div>
                  <div
                    className=""
                    onClick={() => navigate(`/${language}/create-tournament`)}
                  >
                    <button className="btn btn-primary text-nowrap ml-auto">
                      {t("seeAll")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Tournaments;
